module.exports = __webpack_public_path__ + "img/index-comp-pic6.43c856ae.png";